import type { Channel, Environment } from 'types/masterData'
import checkoutEnvVars from '../../../apps/checkout-shop/config/env/shop/dev.json' with {
	type: 'json',
}
import siteEnvVars from '../../../apps/site-shop/config/env/shop/dev.json' with {
	type: 'json',
}

type TypedEnvVars = {
	NEXT_PUBLIC_CHANNEL: Channel
	NEXT_PUBLIC_ENV: Environment
	VERCEL: string
}

type EnvVars = (typeof siteEnvVars & typeof checkoutEnvVars) & TypedEnvVars

function isClient() {
	return Object.keys(process.env).length === 0
}

export const env = new Proxy(
	{
		NEXT_PUBLIC_CHANNEL: process.env.NEXT_PUBLIC_CHANNEL as Channel,
		NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV as Environment,
		NEXT_PUBLIC_GTM_SERVER_SIDE: process.env
			.NEXT_PUBLIC_GTM_SERVER_SIDE as string,
		NEXT_PUBLIC_SITE_BASE_URL: process.env.NEXT_PUBLIC_SITE_BASE_URL as string,
		NEXT_PUBLIC_API_DOMAIN: process.env.NEXT_PUBLIC_API_DOMAIN as string,
		NEXT_PUBLIC_CURRENT_ORIGIN: process.env
			.NEXT_PUBLIC_CURRENT_ORIGIN as string,
		NEXT_PUBLIC_ANALYTICS_MEASUREMENT_ID: process.env
			.NEXT_PUBLIC_ANALYTICS_MEASUREMENT_ID as string,
		FF_OPTIMIZELY_SDK: process.env.FF_OPTIMIZELY_SDK as string,
		NEXT_PUBLIC_AB_TEST_OPTIMIZELY_SDK: process.env
			.NEXT_PUBLIC_AB_TEST_OPTIMIZELY_SDK as string,
		NEXT_PUBLIC_STATIC_CONFIG_ACCESS_TOKEN: process.env
			.NEXT_PUBLIC_STATIC_CONFIG_ACCESS_TOKEN as string,
		NEXT_PUBLIC_LEGAL_DELIVERYTOKEN: process.env
			.NEXT_PUBLIC_LEGAL_DELIVERYTOKEN as string,
		NEXT_PUBLIC_CARD_PAYMENT_IFRAME_URL: process.env
			.NEXT_PUBLIC_CARD_PAYMENT_IFRAME_URL as string,
		NEXT_PUBLIC_HELP_CS_ACCESS_TOKEN: process.env
			.NEXT_PUBLIC_HELP_CS_ACCESS_TOKEN as string,
		NEXT_PUBLIC_HELP_CS_PREVIEW_TOKEN: process.env
			.NEXT_PUBLIC_HELP_CS_PREVIEW_TOKEN as string,
		NEXT_PUBLIC_REGISTRY_PERSONALIZATION_HEADER: process.env
			.NEXT_PUBLIC_REGISTRY_PERSONALIZATION_HEADER as string,
		NEXT_PUBLIC_IS_APP: process.env.NEXT_PUBLIC_IS_APP as string,
		NEXT_PUBLIC_IRIS_CHAT_URL: process.env.NEXT_PUBLIC_IRIS_CHAT_URL as string,
		NEXT_PUBLIC_ADYEN_CLIENT_KEY: process.env
			.NEXT_PUBLIC_ADYEN_CLIENT_KEY as string,
		NEXT_PUBLIC_PAYPAL_CLIENT_ID: process.env
			.NEXT_PUBLIC_PAYPAL_CLIENT_ID as string,
		NEXT_PUBLIC_CIAM_CLIENT_ID: process.env
			.NEXT_PUBLIC_CIAM_CLIENT_ID as string,
		NEXT_PUBLIC_ORCHESTRATOR_DOMAIN: process.env
			.NEXT_PUBLIC_ORCHESTRATOR_DOMAIN as string,
		NEXT_PUBLIC_ADOBE_DAM_DOMAIN: process.env
			.NEXT_PUBLIC_ADOBE_DAM_DOMAIN as string,
		NEXT_PUBLIC_IRIS_DOMAIN: process.env.NEXT_PUBLIC_IRIS_DOMAIN as string,
		NEXT_PUBLIC_CHATBOT_MAPS_API_KEY: process.env
			.NEXT_PUBLIC_CHATBOT_MAPS_API_KEY as string,
		VERCEL: process.env.VERCEL as string,
		NEXT_PUBLIC_WOOSMAP_API_KEY: process.env
			.NEXT_PUBLIC_WOOSMAP_API_KEY as string,
	} as EnvVars,
	{
		get(target, name) {
			if (typeof name !== 'string') {
				throw new Error('Accessing env with symbol is not allowed')
			}
			const isVercelEnv = name.startsWith('VERCEL')
			if (process.env[name]) {
				return process.env[name]
			}
			if (isClient() && !name.startsWith('NEXT_PUBLIC_') && !isVercelEnv) {
				throw new Error(
					`Environment variable ${name} is server only and can't be used in the client`
				)
			}
			if (!target[name as keyof EnvVars] && !isVercelEnv) {
				throw new Error(`Environment variable ${name} is not defined`)
			}

			return target[name as keyof EnvVars]
		},
	}
)
